import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  generateSearchFormItem,
  getTreeData,
  mapEnumToList,
} from "../../../../utils/helper";
import { SearchAccordion } from "../../../common";
import {
  defaultFilter,
  GameStatusEnum,
  GameTagEnum,
  ISearchProps,
} from "./type";

const Search = ({ filter, data, setFilter }: ISearchProps) => {
  const { t } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "text",
                  name: "gameID",
                  label: "GameManagement.gameID",
                },
                {
                  type: "text",
                  name: "name",
                  label: "GameManagement.name",
                },
                {
                  type: "multiSelect",
                  name: "tags",
                  label: "GameManagement.tags",
                  treeData: getTreeData(mapEnumToList(GameTagEnum)),
                },
                {
                  type: "multiSelect",
                  name: "lobbyStatus",
                  label: "GameManagement.lobbyStatus",
                  treeData: getTreeData(mapEnumToList(GameStatusEnum)),
                },
                {
                  type: "multiSelect",
                  name: "clubStatus",
                  label: "GameManagement.clubStatus",
                  treeData: getTreeData(mapEnumToList(GameStatusEnum)),
                },
              ],
              defaultFilter(),
              t,
              data
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
